/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserProfileDto } from '../models/UserProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserSettingsService {
    /**
     * Get current user profile
     * @returns UserProfileDto Successfully retrieved user profile
     * @throws ApiError
     */
    public static getCurrentUserProfile(): CancelablePromise<UserProfileDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/me',
            errors: {
                401: `JWT token missing or invalid`,
            },
        });
    }
    /**
     * Update visibility range setting
     * @param visibilityRangeKm Max visibility distance in km
     * @returns void
     * @throws ApiError
     */
    public static updateVisibilityRange(visibilityRangeKm: number): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/users/me/visibility-range',
            body: { visibilityRangeKm },
            mediaType: 'application/json',
            errors: {
                401: `JWT token missing or invalid`,
                403: `Only sports clubs can set visibility range`,
            },
        });
    }
}
